module.exports = __webpack_public_path__ + "static/media/38_KlausSiebald_webfinal.6fdc7338.jpg";